import { createActionsColumn } from '@app/modules/audit/components/create-actions-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { AuditSchedule } from '@mi-front/core';
import { BtnLink, MrtTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { LDateTime } from '../../../../../../../../components/date/LDateTime';
import { ReportResultProps } from '../../../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../../../core/stations/hooks/useActiveStation';
import { MissingAudiosReport } from './types';

import { FormattedMessage } from 'react-intl';
export function MissingAudiosReportResult(p: ReportResultProps<MissingAudiosReport>) {
  const { $t } = useIntl();

  const station = useActiveStation();

  const viewScheduleUrlFn = (schedule: AuditSchedule) =>
    `/audit/s/${station.slug}/schedule/spot/${schedule.id}`;

  return (
    <MrtTable
      data={p.result.items}
      columns={[
        {
          id: 'datetime',
          header: $t({
            id: 'audit.reportsScreen.missingAudios.datetime',
            defaultMessage: 'Fecha y hora programada (primera entrada)',
          }),
          accessorKey: 'datetime',
          Cell: ({ row }) => <LDateTime value={row.original.datetime} />,
        },
        createCustomIdColumn<AuditSchedule>($t, {
          accessor: (row) => row.customId,
          filterFn: 'contains',
        }),
        createActionsColumn<AuditSchedule>($t, {
          size: 220,
          Cell: ({ row }) => (
            <BtnLink
              size="xs"
              to={viewScheduleUrlFn(row.original)}
              openInNewTab
              icon={<OpenInNewIcon />}
              className="mr-2"
            >
              <FormattedMessage
                id="audit.reportsScreen.missingAudios.viewScheduleBtn"
                defaultMessage="Ver detalle de entrada"
              />
            </BtnLink>
          ),
        }),
      ]}
    />
  );
}
